import OfferInterface from '../interfaces/offer.interface';
import { SortType } from '../reducers/offers';

export function offersSort(selectedSort: SortType): (prev: OfferInterface, next: OfferInterface) => number {
    if (selectedSort === SortType.BestOffer) {
        return (prev: OfferInterface, next: OfferInterface): number => next.score - prev.score;
    }

    if (selectedSort === SortType.Price) {
        return (prev: OfferInterface, next: OfferInterface): number => prev.price - next.price;
    }

    if (selectedSort === SortType.ShopScore) {
        return (prev: OfferInterface, next: OfferInterface): number => {
            if (!prev.dealer.opinions) {
                return 1;
            }

            if (!next.dealer.opinions) {
                return -1;
            }

            return next.dealer.opinions?.average - prev.dealer.opinions?.average;
        };
    }

    return (): number => 0;
}
